import { PlantingEvents, StoreCrops } from '../../types';
import { QueryPlantingEventsResponse } from './types/QueryPlantingEventsResponse';
import data from './mocks/plantingQueryMock.json';
import { adaptUapiPlantingResponse } from './uapiResponseAdapter';
import { LegacyCropsMap } from './types/LegacyCropsMap';

export async function requestUapiPlantingEvents(_fieldUuid: string, cropsMap: StoreCrops): Promise<PlantingEvents> {
  // TODO AREP-3099: Integrate real query;
  // const response = (await uapiConnection(
  //   getPlantingQuery(params)
  // )) as QueryPlantingEventsResponse;

  const mockData = await Promise.resolve(data);
  const response = mockData as QueryPlantingEventsResponse;

  const crops: LegacyCropsMap = Object.entries(cropsMap).reduce((accum, [legacySeasonCode, crop]) => ({
      ...accum,
      [crop.uuid]: legacySeasonCode,
    }), {});

  return adaptUapiPlantingResponse(response.data.field.plantingEventAggregates?.eventsByCropSeason || [], crops);
}
